import React, { Component } from 'react'

import KebabmenuComponent from './Kebabmenu.component'

class KebabmenuContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false
    }

    this.ref = React.createRef()
    this.boundHandleClickOutside = this.handleClickOutside
  }

  componentDidMount() {
    window.addEventListener('click', this.boundHandleClickOutside)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.boundHandleClickOutside)
  }

  handleClickOutside = (evt) => {
    if (!this.ref.current || this.ref.current.contains(evt.target)) {
      return false
    }

    this.setState({
      open: false
    })
  }

  handleClick = (evt) => {
    evt.preventDefault()

    const open = !this.state.open

    this.setState({
      open
    })
  }

  render() {
    const {open} = this.state

    const events = {
      handleClick: this.handleClick
    }

    return (
      <KebabmenuComponent open={open} analytics={this.props.analytics} env={this.props.env} events={events} extRef={this.ref} actions={this.props.actions} dataRow={this.props.dataRow} />
    )
  }
}

export default KebabmenuContainer
